<template>
  <div class="mine-page">
    <van-nav-bar :border="false" @click-left="$store.dispatch('back')" placeholder>
      <template #left>
         <van-icon size="20px" name="arrow-left" color="#555555"/>
      </template>
    </van-nav-bar>
    <div class="top">
    开通 <span>会员</span>，享万元课程
  </div>
  <div class="main">
    <div class="menu">
      <div v-for="(item,index) in menuList" :key="index" @click="choose(index)" class="menuItem" :class="{active:active==index}">
          <div class="itemName">{{item.name}}</div>
          <div class="price_promote">￥<span>{{item.price_promote}}</span></div>
          <div class="price">￥{{item.price}}</div>
      </div>
    </div>
    <div class="rule">
      <p>会员规则：</p>
      <div>
        1.购买高研院会员，可以查看京学高研院所
      </div>
      <div>
        2.该会员属于虚拟产品，一概售出概不退换
      </div>
    </div>
  </div>
  <div class="btn">
    <div>
      确认并支付{{menuList[active].price_promote}}元
    </div>
  </div>
  </div>
</template>


<script>
import store from "@/store/index.js";
import "vant/es/list/style/index";
export default {
  components: {
  },
  data(){
    return{
      active:0,
    menuList:[{
      name:'京学高研院会员',
      price:2399,
      price_promote:1399,
    },{
      name:'托育高研院会员',
      price:2399,
      price_promote:1499,
    },{
      name:'幼教高研院会员',
      price:2399,
      price_promote:1599,
    },{
      name:'0-3岁家长研修社',
      price:2399,
      price_promote:1699,
    },{
      name:'3-6岁家长研修社',
      price:2399,
      price_promote:1799,
    }],
    }
  },
  computed: {
   
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
  },
  methods: {
    kefu(){
      window.location.href = 'tel:400-605-6968';
    },
    goPurchased() {
      this.$store.dispatch("jump", {
        path: "../user/purchased",
        params: '',
      });
      
    },
    choose(index) {
      this.active = index
    },
  },
};
</script>

<style scoped>
  :deep .van-nav-bar{
    background-color: transparent;
  }
  
  .mine-page {
  background: #fff url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/vipBg.png') top center no-repeat;
  background-size: contain;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}
.mine-page .main{
  flex:1;
}
.mine-page .top{
  color: #70481E;
  font-size: 40px;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 50px;
}
.mine-page .top span{
  font-size: 58px;
}
.mine-page .menu {
  margin-top: 130px;
}
.mine-page .menu{
  padding-left: 31px;
}
.mine-page .menu .menuItem{
  display: inline-flex;
  width: 216px;
  height: 216px;
  background: #FFFFFF;
  box-shadow: 0px 2px 20px 0px rgba(229,229,229,0.5);
  border-radius: 20px;
  margin-right: 22px;
  text-align: center;
  color: #333333;
  font-size: 24px;
  margin-bottom: 60px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.mine-page .menu .menuItem .price_promote{
  margin: 20px auto;
}
.mine-page .menu .menuItem span{
  font-size: 40px;
}
.mine-page .menu .menuItem .price{
  color: #D5BB5D;
  text-decoration: line-through;
}
.mine-page .menu .active{
  box-shadow: 0px 2px 20px 0px rgba(239, 239, 239, 1);
  background-color: rgba(255, 250, 233, 1);
  border-radius: 20px;
  border: 2px solid rgba(239, 199, 120, 1);
  box-sizing: border-box;
}
.mine-page .menu .active .price_promote{
  color: #70481E;
}
.mine-page .rule{
  padding: 0 30px;
  color: #666666;
  font-size: 26px;
  line-height: 37px;
}
.mine-page .rule p{
  color: #333333;
  font-weight: bold;
  padding-bottom: 20px;
  display: block;
}
.btn{
  width: 100vw;
  height: 130px;
  background: #FFFFFF;
  box-shadow: 0px -1px 5px 0px rgba(221,217,217,0.5);
}
.btn div{
  width: 646px;
  height: 90px;
  border-radius: 44px;
  border: 2px solid #A7090A;
  margin: 20px auto;
  text-align: center;
  line-height: 90px;
  font-size: 34px;
  color: #A7090A;
  font-weight: 500;
}
</style>